module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "icon",
    class: [_vm.name]
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "viewBox": "0 0 1040 1040",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('path', {
    attrs: {
      "fill": _vm.color,
      "d": _vm.icons[_vm.name]
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d8596d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/_components/icon/icon.vue
// module id = 128
// module chunks = 10